import React from 'react';

import { DevicesView } from './devicesView'
const { formatText } = require('core/i18n').i18n;


class DevicesForgottenView extends React.PureComponent {
    render() {
        const gridTitle = formatText("manageDevices-explanationHiddenTextTitle")
        const gridDescription = formatText("manageDevices-explanationHiddenTextDesc")
        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__ ?
                {
                    text: formatText("profileKeysLanding-title"),
                    url: "/myprofile/keys"
                } : []),
            {
                text: formatText("breadcrumb-recentActivity"),
                url: "/myprofile/devices"
            },
            {
                text: formatText("breadcrumb-hiddenDevices")
            }
        ]

        return (
            <DevicesView
                forgotten={true}
                breadcrumb={mappingBreadcrumb}
                headerKey={'landingHeader-manageHiddenDevices'}
                firstTableTitle={gridTitle}
                firstTableDescription={gridDescription}
            />
        );
    }
}

export default { DevicesForgottenView }
